import React from "react";
import { Chip } from '@mui/material'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'

const DownloadFile = (props: any) => {
    return (
        <Chip
          icon={<CloudDownloadIcon />}
          label={props.file.attachmentFilename}
          clickable
          className='btnBlue'
          onClick={() => props.download(props.file.id)}
          color="primary"
          onDelete={ () => props.delete(props.file.id)}
      />
    )
}

export default DownloadFile